import { render, staticRenderFns } from "./FormTopics.vue?vue&type=template&id=6955f7f2&"
import script from "./FormTopics.vue?vue&type=script&lang=js&"
export * from "./FormTopics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports